<div *ngIf="data">
    <app-template [name]="template" [data]="data"></app-template>
</div>